import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { Store } from '@ngrx/store';
import { OnboardingState } from 'app/profile/store/state/onboarding.state';import * as OnboardingActions from '../../../store/actions/onboarding.actions';
import { OnboardingTab, TaskStatus } from 'app/profile/models/onboarding.model';
import { Observable, forkJoin } from 'rxjs';
import { ContextVerbiage, EmailDomain, OPERATION, SupplierDocument } from 'app/profile/models/supplier.model';
import { SupplierTaskResponse, SupplierTaskStep, SupplierTaskTableCol, SupplierTaskTableMasterData } from 'app/profile/models/suppliertasks.model';
import { DomainEditComponent } from 'app/common/domain/domain-edit.component';
import { ActivatedRoute, Router } from '@angular/router';
import { TslDialog, TslToastrService } from '@tesla/ng-tds';
import { SupplierTaskService } from 'app/profile/services/supplier-task.service';
import { I18nService } from 'app/shared/services/i18n.service';
import * as MasterDataSelectors from "../../../store/selectors/masterdata.selector";
import { SupplierStateService } from 'app/profile/services/supplierstate.service';
import { cloneDeep } from "lodash";
import { MatDialog } from '@angular/material/dialog';
import { DomainTaskDialogComponent } from './domain-task-dialog/domain-task-dialog.component';
import { ExistSelectComponent } from '../exist-select/exist-select.component';

import * as FileSaver from 'file-saver';
import { FileUploadService } from 'app/common/services/fileUpload.service';
@Component({
  selector: 'app-domain-task-wrapper',
  templateUrl: './domain-task-wrapper.component.html',
  styleUrls: ['./domain-task-wrapper.component.scss']
})
export class DomainTaskWrapperComponent implements OnInit, OnDestroy {
  @ViewChild('domainEdit', { static: false }) domainEditComponent: DomainEditComponent;
  @ViewChild('selectTable', { static: false }) selectTableComponent: ExistSelectComponent;

  @Input('supplierCode') set _supplierCode(val: string) { if (val && val.trim() != "") this.supplierCode = val; };
  @Input('taskId') set _taskId(val: number) { if (val) this.taskId = val; };
  @Output() onSave: EventEmitter<boolean> = new EventEmitter<boolean>();
  
  onboardingTab: OnboardingTab = OnboardingTab.DOMAIN;
  domainDifferenceReasons$: Observable<string[]>;
  contextVerbiage: ContextVerbiage;
  supplierCode: string = null;
  taskId: number;
  isLoaded: boolean = false;
  emailDomain: EmailDomain = new EmailDomain();
  emailDomainList: EmailDomain[];
  taskStatus: string;
  rejectionDetails: any;
  taskInfo: SupplierTaskStep;
  requestType: string;
  existingItemList: EmailDomain[];
  displayedColumns: SupplierTaskTableCol[] = [];
  tableData: SupplierTaskTableMasterData;
  isValidSelectTable: boolean = true;
  selectedIndexList: number[] = [];
  unSelectedIndexList: number[] = [];
  tableErrorMessage: string;
  
  constructor(
    private onboardingStore: Store<OnboardingState>,
    private route: ActivatedRoute,
    private tslDialog: TslDialog,
    private taskService: SupplierTaskService,
    private toaster: TslToastrService,
    private router: Router,
    private translate: I18nService,
    private supplierStateService: SupplierStateService,
    private matDialog: MatDialog,
    private fileUploadService: FileUploadService,
  ) { }

  ngOnInit(): void {
    this.route?.parent?.params?.subscribe(params => {
      if (params?.code && params?.portalTaskId) {
        this.supplierCode = params.code;
        this.taskId = params.portalTaskId;
      }
    });

    this.onboardingStore.select(MasterDataSelectors.SelectContextVerbiage).subscribe(contextVerbiage => this.contextVerbiage = contextVerbiage);

    this.taskService.getSupplierTaskStep(this.supplierCode, this.taskId, this.onboardingTab).subscribe(taskInfo => {
      if (taskInfo && taskInfo.taskConfiguration) {
        this.taskInfo = taskInfo;
        this.requestType = this.taskInfo?.taskConfiguration?.SupplierRequestType;
        if(this.requestType) this.requestType = this.requestType[0].toLocaleLowerCase() + this.requestType.substring(1);
        this.taskStatus = taskInfo.taskStatus;
        this.rejectionDetails = taskInfo?.rejectionDetails;
        if (this.taskStatus != TaskStatus.Completed && taskInfo.portalTaskResponse != null) {
          if(["nameOrTINChange"].includes(this.requestType)) {
            if(!taskInfo.portalTaskResponse.length) this.emailDomainList = [{
              operation: taskInfo.portalTaskResponse?.Operation,
              id: taskInfo.portalTaskResponse?.ID,
              stageID: taskInfo.portalTaskResponse?.StageID,
              additionalReason: taskInfo.portalTaskResponse?.AdditionalReason,
              website: taskInfo.portalTaskResponse?.Website,
              domain: taskInfo.portalTaskResponse?.Domain,
              reason: taskInfo.portalTaskResponse?.Reason,
              comment: taskInfo.portalTaskResponse?.Comment,
              documents: taskInfo.portalTaskResponse?.Documents,
              documentInfos: taskInfo.portalTaskResponse?.DocumentInfos,
            }];
            else this.emailDomainList = taskInfo.portalTaskResponse
              ?.map(x => {return {
                operation: x.Operation,
                id: x.ID,
                stageID: x.StageID,
                website: x.Website,
                domain: x.Domain,
                reason: x.Reason,
                comment: x.Comment,
                additionalReason: x.AdditionalReason,
                documents: x.Documents,
                documentInfos: x.DocumentInfos,
              };})
              ?.filter(x => x.operation != OPERATION.DELETE);
          } else this.emailDomain = {
            operation: taskInfo.portalTaskResponse?.Operation,
            id: taskInfo.portalTaskResponse?.ID,
            stageID: taskInfo.portalTaskResponse?.StageID,
            additionalReason: taskInfo.portalTaskResponse?.AdditionalReason,
            website: taskInfo.portalTaskResponse?.Website,
            domain: taskInfo.portalTaskResponse?.Domain,
            reason: taskInfo.portalTaskResponse?.Reason,
            comment: taskInfo.portalTaskResponse?.Comment,
            documents: taskInfo.portalTaskResponse?.Documents,
            documentInfos: taskInfo.portalTaskResponse?.DocumentInfos,
          };
        }

        if(["nameOrTINChange"].includes(this.requestType)) {
          // use supplier code and based on type to grab item list
          this.supplierStateService.getDomainListByCode(this.supplierCode).subscribe(resList => {
            this.existingItemList = resList?.map(x => ({
              comment: x?.comment?.newValue,
              id: x?.id?.newValue,
              documents: x?.documents?.newValue,
              domain: x?.domain?.newValue,
              stageID: x?.stageID?.newValue,
              operation: x?.operation?.newValue,
              additionalReason: x?.additionalReason?.newValue,
              website: x?.website?.newValue,
              reason: x?.reason?.newValue,
            }));
            this.initTableData();
          })
        } else this.isLoaded = true;
      }
    });
  }

  initTableData() {
    this.displayedColumns = [
      {propertyName: "domain", title: "Domain"},
      {propertyName: "reason", title: "Reason"},
      {propertyName: "website", title: "Website"}
    ];
    let existIndexList = [];
    this.emailDomainList?.forEach(email => {
      if(email) {
        let existIndex = this.existingItemList?.findIndex(x => x.id == email.id && email.id != 0);
        if(existIndex < 0) {
          if(!this.existingItemList.length) this.existingItemList = [];
          email.operation = OPERATION.CREATE;
          existIndexList.push(this.existingItemList.push(cloneDeep(email)) - 1);
        } else {
          this.existingItemList[existIndex] = cloneDeep(email);
          if(email.operation !== OPERATION.DELETE) existIndexList.push(existIndex)
        }
      }
    });

    let selectHeader;
    selectHeader = "Please confirm if this information is still active.";

    this.tableData = {
      supplierCode: this.supplierCode,
      onboardingTab: this.onboardingTab,
      selectHeader: selectHeader,
      disableCreateNew: false,
      enableFirstEdit: false,
      disableEdit: true,
      disableView: true,
      enableMultiSelect: ["nameOrTINChange"].includes(this.requestType),
      enablePrimarySelect: false,
      enableDocumentUpload: false,
      showMessage: true,
      enableAddNew: true,
      displayTitle: false,
      createNewLabel: "ADD NEW DOMAIN DETAILS",
      data: this.existingItemList?.map((x, index) => {
        let obj = {
          domain: x.domain,
          reason: this.translate.get(x.reason),
          website: x.website,
          value: x.id,
          isNew: x.operation == OPERATION.CREATE
        };
        if(existIndexList?.includes(index)) {
          obj["isSelected"] = true;
          this.isValidSelectTable = true;
          if(!this.selectedIndexList) this.selectedIndexList = [];
          this.selectedIndexList.push(index);
        } else if(existIndexList?.length || (!!(this.emailDomainList?.length  && !existIndexList?.length))) {
          this.unSelectedIndexList.push(index);
          obj["isSelected"] = false;
        }
        return obj;
      })
    };
    this.isLoaded = true;
  }

  onSelected(index) {
    this.isValidSelectTable = true;
    if(["nameOrTINChange"].includes(this.requestType)) {
      if(!this.selectedIndexList) this.selectedIndexList = [];
      if(!this.unSelectedIndexList) this.unSelectedIndexList = [];
      if(index < 0) {
        if(this.selectedIndexList.includes(-(index + 1))) {
          index = -(index + 1);
          this.selectedIndexList.splice(this.selectedIndexList.indexOf(index), 1);
          this.unSelectedIndexList.push(index);
        } else this.unSelectedIndexList.push(-(index + 1));
      } else {  
        if(this.selectedIndexList.includes(this.existingItemList?.length)) this.selectedIndexList.splice(this.selectedIndexList.indexOf(this.existingItemList?.length), 1);
        this.selectedIndexList.push(index);
        if(this.unSelectedIndexList.includes(index)) this.unSelectedIndexList.splice(this.unSelectedIndexList.indexOf(index), 1);
      }
    }
  }

  onEdit(event) {
    let index = event?.index;
    if(index < this.existingItemList?.length) {
      const dialogRef = this.matDialog.open(DomainTaskDialogComponent,
        { 
          width: '1100px', 
          maxHeight: '80vh',
          autoFocus: false,
          data: { 
            supplierCode: this.supplierCode, 
            emailDomain: cloneDeep(this.existingItemList[index]),
            domainDifferenceReasons$: this.domainDifferenceReasons$,
            existingDomains: this.existingItemList?.filter((x, i) => index != i)?.map(x => x.domain)
          } 
        }
      );
      dialogRef.afterClosed().subscribe(res => {
        if(res) {
          res.id = this.existingItemList[index]?.id;
          res.operation = this.existingItemList[index]?.operation;
          this.existingItemList[index] = res;
          this.reloadTableData();
        } else {
          if(event?.isFirstTime) {
            this.selectTableComponent?.onSelectSwitch(null, index, false);
          }
        }
      });
    }
  }

  onDelete(event) {
    let index = event?.index;
    this.selectedIndexList.splice(this.selectedIndexList.indexOf(index), 1);
    this.existingItemList.splice(index, 1);
    this.reloadTableData();
  }

  reloadTableData() {
    this.selectTableComponent?.updateTableData(this.existingItemList?.map((x, index) => {
      let obj = {
        domain: x.domain,
        reason: x.reason,
        website: x.website,
        value: x.id,
        isNew: x.operation == OPERATION.CREATE
      };
      if(this.selectedIndexList?.includes(index)) {
        obj["isSelected"] = true;
        this.isValidSelectTable = true;
      } else {
        if(["nameOrTINChange"].includes(this.requestType)) {
          if(this.unSelectedIndexList?.includes(index)) obj["isSelected"] = false;
        } else if(this.selectedIndexList?.length || (!!(this.emailDomainList?.length  && !this.selectedIndexList?.length))) obj["isSelected"] = false;
      }
      return obj;
    }), !["nameOrTINChange"].includes(this.requestType));
  }

  onAdd() {
    const dialogRef = this.matDialog.open(DomainTaskDialogComponent,
      { 
        width: '1100px', 
        maxHeight: '80vh',
        autoFocus: false,
        data: { 
          supplierCode: this.supplierCode,
          domainDifferenceReasons$: this.domainDifferenceReasons$,
          existingDomains: this.existingItemList?.map(x => x.domain)
        } 
      }
    );
    dialogRef.afterClosed().subscribe(res => {
      if(res) {
        res.operation = OPERATION.CREATE;
        this.selectedIndexList.push(this.existingItemList.push(cloneDeep(res)) - 1);
        this.reloadTableData();
      }
    });
  }

  setErrorMessage(errorMessage: string) {
    if (errorMessage) this.onboardingStore.dispatch(OnboardingActions.SetErrorMessage({ errorMessage }));
  }

  emailDomainSubmit(domain: EmailDomain) {
    this.onProcessEvent(domain);
  }

  onProcessEvent(domain: EmailDomain) {
    // future usage
  }

  onSubmit() {
    if(["nameOrTINChange"].includes(this.requestType)) {
      if(!this.selectedIndexList?.length) {
        this.isValidSelectTable = false; 
        this.tableErrorMessage = "Please confirm at least one active domain above or add new information."
        return;
      }
      if(this.selectedIndexList?.length + this.unSelectedIndexList?.length != this.existingItemList?.length) {
        this.isValidSelectTable = false; 
        this.tableErrorMessage = "Please make decision for all items."
        return;
      }
      let submitList = this.existingItemList.map((item, index) => {
        if(this.selectedIndexList.findIndex(x => x == index) < 0) item.operation = OPERATION.DELETE;
        else if(item.operation != OPERATION.CREATE) item.operation = OPERATION.UPDATE;
        return item;
      });
      let uploadObsList = [];
      let uploadIndexList = [];
      submitList.forEach((x, index) => {
        if(x.documentInfos?.length && x.documentInfos[0]) {
          if(!x.documentInfos[0].DocumentID) {
            if(x.documentInfos[0].File?.name) {
              uploadObsList.push(this.fileUploadService.uploadFileToServer([x.documentInfos[0].File], this.supplierCode).map(res => {
                let file = new SupplierDocument();
                file.DocumentID = res['documentID'] || res.DocumentID;
                file.DocumentVersion = res['documentVersion'] || res.DocumentVersion;
                file.FileName = res['fileName'] || res.FileName;
                file.DocumentType = "CORR-ED";
                return file;
              }));
              uploadIndexList.push(index);
            }
          } else {
            x.documents = x.documentInfos?.map(x => x.DocumentID);
          }
        }
      });
      if(uploadObsList.length) {
        forkJoin(uploadObsList).subscribe(res => {
          res?.forEach((x, index) => {
            submitList[uploadIndexList[index]].documentInfos = [x as SupplierDocument];
            submitList[uploadIndexList[index]].documents = submitList[uploadIndexList[index]].documentInfos?.map(x => x.DocumentID)
          });
          this.postDomainListTask(submitList);
        });
      } else this.postDomainListTask(submitList);
    } else {
    }
  }

  postDomainListTask(submitList: EmailDomain[]) {
    let body = cloneDeep(submitList);
    var response: SupplierTaskResponse = {
      id: this.taskId,
      supplierCode: this.supplierCode,
      taskResponseJson: JSON.stringify(body),
      action: 'Submit'
    }
    this.taskService.postSupplierTaskStepResponse(this.supplierCode, response).subscribe(res => {
      if (res) {
        this.toaster.success(this.translate.get('Submitted successfully!'));
        this.onSave.emit(true);
        this.router.navigate([`${this.supplierCode}`, "Onboarding", "Home"]);
      }
      else {
        this.toaster.error(this.translate.get('Something went wrong!'));
      }
    },
      err => this.toaster.error(this.translate.get('Something went wrong!')));
  }

  ngOnDestroy(): void {
  }
}
